import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { path: '/services/gcc', label: 'GCC as a Service' },
    { path: '/services/hr-service', label: 'HR as a Service' },
    { path: '/services/product-engineering', label: 'Product Engineering' },
    { path: '/services/infrastructure-security', label: 'Infrastructure & Security' },
    { path: '/services/special-engagements', label: 'Special Engagements' },
    { path: '/services/ai-innovation', label: 'AI & Innovation' },
  ];

  const companyLinks = [
    { path: '/about', label: 'About' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' },
    { path: '/annualreturn', label: 'Annual Return' },
  ];

  const handleLinkClick = () => {
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__section">
            <h3>Cospin</h3>
            <p>Accelerating Digital Transformation. Empowering Global Capability.</p>
            <p style={{ marginTop: 'var(--space-16)' }}>
              <a href="mailto:admin@cospin.in">admin@cospin.in</a>
            </p>
            <div className="footer__social" style={{ marginTop: 'var(--space-16)' }}>
              <a
                href="https://www.linkedin.com/company/cospin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on LinkedIn"
                className="footer__social-link"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer__section">
            <h4>Services</h4>
            <ul>
              {services.map((service) => (
                <li key={service.path}>
                  <Link to={service.path} onClick={handleLinkClick}>{service.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__section">
            <h4>Company</h4>
            <ul>
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} onClick={handleLinkClick}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__section">
            <h4>Chennai</h4>
            <div className="footer__address">
              <p>
                Module 5, II Floor<br />
                Centre for Innovation Building<br />
                St.Joseph's College of Engineering<br />
                Semmencherry, OMR<br />
                Chennai – 600119
              </p>
              <p>
                <a href="tel:+919840223344">+91 98402 23344</a>
              </p>
            </div>
          </div>

          <div className="footer__section">
            <h4>Bangalore</h4>
            <div className="footer__address">
              <p>
                WeWork Prestige Cube<br />
                # 26, Laskar Hosur Road<br />
                Adugodi, Koramangala<br />
                Bengaluru, Karnataka 560030
              </p>
              <p>
                <a href="tel:+919884578933">+91 98845 78933</a>
              </p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {currentYear} Cospin. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
